import React from 'react';
import PropTypes from 'prop-types';

const LearningQuizPassedIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.6 7.7l5.8-.8z"
      fill={color}
    />
  </svg>
);

LearningQuizPassedIcon.propTypes = {
  color: PropTypes.string,
};

export default LearningQuizPassedIcon;
